import { NotesV2 } from '../../UI';
import { CashAccountFormValues } from '../types';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';

interface CashAccountNotesInputProps {
  className?: string;
}

export const CashAccountNotesInput = ({ className }: CashAccountNotesInputProps) => {
  const { t: tCommon } = useTranslation('common');
  const { control } = useFormContext<CashAccountFormValues>();
  const { field, fieldState } = useController<CashAccountFormValues, 'notes'>({
    control,
    name: 'notes',
  });

  return (
    <NotesV2
      {...field}
      className={className}
      label={tCommon('notes')}
      defaultValue={field.value}
      status={fieldState.error ? 'errored' : 'normal'}
    />
  );
};
